import React, { Component } from "react";
import { connect } from "react-redux";
import PageRoutes from "./routers/pageRoutes";

import "react-notifications/lib/notifications.css";
import "perfect-scrollbar";
import "./App.scss";

// import NavBar from './containers/navBar';
// import SideBar from './containers/sideBar';
// import MainRoutes from './routers/mainRoutes';

class App extends Component {
  render() {
    return (
      <div className="App">
        <div className="appFrame">
          <PageRoutes />
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  user: state.cognito.user
});

App = connect(mapStateToProps)(App);

export default App;
